import { useDevice } from '#imports'

export default class DeviceService {
	public static isMobile(): boolean {
		const { isMobile } = useDevice()
		return isMobile
	}

	public static isIos(): boolean {
		const { isIos } = useDevice()
		return isIos
	}
}
